import { createFileRoute } from '@tanstack/react-router';
import { ProfilePage } from '../components/community/ProfilePage';

export const Route = createFileRoute('/community/profile/$userId')({
  component: ProfilePage,
});
